import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/** Compact summary for related metrics; callers supply only verified values. */
export function MetricPanel({ title, items }: { title: string; items: Array<{ label: string; value: ReactNode }> }) {
  return <Card sx={{ height: '100%' }}><CardContent>
    <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
    <Stack divider={<Divider />} spacing={1.5}>
      {items.map(item => <Box key={item.label} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'baseline' }}>
        <Typography variant="body2" color="text.secondary">{item.label}</Typography>
        <Typography variant="h6" sx={{ fontVariantNumeric: 'tabular-nums' }}>{item.value}</Typography>
      </Box>)}
    </Stack>
  </CardContent></Card>;
}
